import * as React from 'react';
import Scenario from '../../models/Scenario';
import * as _ from 'lodash';

import './Statistics.css';
import '../../../node_modules/c3/c3.css';

import { CriteriaSubject, SuccessCriteria } from '../../models/project/SuccessCriteria';
import { ProjectStore } from '../../stores/project/ProjectStore';
import { Subscriber } from '../../services/util/PubSub';
import ChartRenderer from '../../services/chart/ChartRenderer';

class Statistics extends React.Component<{
  scenarios: Scenario[],
  width: number,
  height: number,
  successCriteria?: SuccessCriteria,
  projectStore: ProjectStore
}, { chartRef, chartId: string }> {
  private chartRef;

  public constructor(props) {
    super(props);

    this.state = {
      chartRef: React.createRef(),
      chartId: 'scenarios-svg-chart'
    };

    // tried to put render call into render(), but #scenarios-svg-chart was not available in DOM during chart initialization
    // also putting it into componentDidMount() failed, b/c scenarios was not available during one time it was called after render()
    this.props.projectStore.addSubscriber(new Subscriber("statistics", () => {
      if (!_.isUndefined(this.props.successCriteria)) {
        const xParameter: CriteriaSubject = this.props.successCriteria.subject;
        const data = _.chain(this.props.scenarios).groupBy((s) => {
          switch (xParameter) {
            case CriteriaSubject.TIME_ESTIMATE:
              return s.getTimeEstimate();
              break;
            case CriteriaSubject.CUSTOM_ESTIMATE:
              return s.getCustomEstimate();
              break;
          }
    
        }).map((group, key) => {
          let total = group.map(g => g.probability).reduce((acc, prob) => { return acc + prob });
          return {
            'estimate': key,
            'probability': total * 100
          };
        })
        .sortBy((p) => { return -parseFloat(p.estimate) })
          .value();

          ChartRenderer.renderBarChart(
            data,
            this.state.chartId,
            this.props.width,
            this.props.height,
            ['probability', 'cumulative probability [%] for custom estimate >= x'],
            'work estimate (h)',
          );
      }
    }));
  }

  componentDidMount() {
  }

  public render() {
    return (
      <React.Fragment>
        <div className="boxed" id="statistics">
          <h2>Success probabilities</h2>

          <div className="chart" id="scenarios-svg-chart" ref={this.chartRef}></div>
        </div>
      </React.Fragment>
    )
  }
}

export default Statistics;



// WEBPACK FOOTER //
// ./src/components/statistics/Statistics.tsx